import { useParams, useNavigate } from 'react-router-dom'
import { SubmitHandler } from 'react-hook-form'

import { BarrierForm } from '@containers/Forms/Barrier'
import { TBarrierForm } from '@containers/Forms/Barrier/schema'
import { useAlerts } from '@hooks/alerts'
import { useDeleteBarrier } from '@hooks/barriers/delete'
import { useEditBarrier } from '@hooks/barriers/edit'
import { useFindBarriers } from '@hooks/barriers/find'
import { IBarrier } from '@interfaces/task/barrier'

export function EditBarrierFormScreen() {
  const { showDismissAlert, showDeleteAlert } = useAlerts()

  const { taskId: taskIdParam, barrierId: barrierIdParam } = useParams<{ taskId: string; barrierId: string }>()
  const taskId = Number(taskIdParam)
  const barrierId = Number(barrierIdParam)
  const navigate = useNavigate()

  const { mutateAsync: deleteBarrier } = useDeleteBarrier()
  const { mutateAsync: putBarrier } = useEditBarrier()

  const { data: barriers } = useFindBarriers(taskId)

  const barrier =
    barriers?.find((barrier) => barrier?.id === barrierId) ?? ({} as IBarrier)

  const handleEditBarrier: SubmitHandler<TBarrierForm> = async (
    data: TBarrierForm,
  ) => {
    const { comment, ...rest } = data

    const changes = { ...barrier, ...rest }

    try {
      await putBarrier({
        changes,
        barrierId,
        taskId,
      })
      navigate(-1)
    } catch {
      window.alert('Error\n\nFailed to save barrier. Please try again.')
    }
  }

  function handleShowAlertOnBarrierDismiss() {
    showDismissAlert(() => navigate(-1))
  }

  function handleShowAlertOnDeleteBarrier() {
    showDeleteAlert('Barrier', callDeleteBarrier)
  }

  async function callDeleteBarrier() {
    try {
      await deleteBarrier({ barrierId, taskId })
      navigate(-1)
    } catch {
      window.alert('Error\n\nFailed to delete barrier. Please try again.')
    }
  }

  return (
    <BarrierForm
      barrier={barrier}
      onSave={handleEditBarrier}
      onClose={handleShowAlertOnBarrierDismiss}
      onDelete={handleShowAlertOnDeleteBarrier}
    />
  )
}
